// module variables
const config = require('./config.json');
const defaultConfig = config.development;
const environment = process.env.NODE_ENV || 'production';
const environmentConfig = config[environment];
const finalConfig = Object.assign({},defaultConfig, environmentConfig);

export default finalConfig;
